import { render, staticRenderFns } from "./PublicWelfareClass.vue?vue&type=template&id=25132e8e&scoped=true"
import script from "./PublicWelfareClass.vue?vue&type=script&lang=js"
export * from "./PublicWelfareClass.vue?vue&type=script&lang=js"
import style0 from "./PublicWelfareClass.vue?vue&type=style&index=0&id=25132e8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25132e8e",
  null
  
)

export default component.exports